<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>환불신청이</span>
                    <span>완료되었습니다.</span>
                </div>
            </div>
          <div @click="closeRefundSucceedPopup()">
            <bottom-button :buttonArray="buttonArray"></bottom-button>
          </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'RefundCancelPopup',
    components: {BottomButton},
    data() {
        return  {
            buttonArray : [
                {
                    className : "button-bg-gray",
                    text : "닫기",
                },
            ],
            barcodeNumber: false,
        }
    },
    methods : {
      closeRefundSucceedPopup(){
        this.$emit('refundSucceedPopup', false);
        this.$router.replace({name: 'saveBox'})
      }
    }
};
</script>

<style lang="scss" scoped>
    @import '/src/assets/styles/global.scss';
    .absolute { position: fixed; bottom: 0; width: 100%; }
    .popup-wrap {
        min-height: rem(66);
        border-radius: rem(24) rem(24) 0 0;
        background-color: $color-white;
        div {
            padding: rem(40) rem(24);
            text-align: center;
            span {
                display: block;
                @include font-size(rem(16), rem(22), 700);
                color: $color-black-400;
            }
        }
    }
</style>